import { render, staticRenderFns } from "./CancelAppointment.vue?vue&type=template&id=2a1876b8&scoped=true&"
import script from "./CancelAppointment.vue?vue&type=script&lang=js&"
export * from "./CancelAppointment.vue?vue&type=script&lang=js&"
import style0 from "./CancelAppointment.vue?vue&type=style&index=0&id=2a1876b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1876b8",
  null
  
)

export default component.exports